import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import {
  Button, Grid, GridList, GridListTile,
} from '@material-ui/core';
import useResponsive from '../../../../utils/responsive';
import ComponentCustomerAddress from './ComponentCustomerAddress';
import { Space } from '../../../common';
import { useLanguage } from '../../../../context/language/language';

const ButtonAddMore = styled(Button)(({ theme }) => ({
  backgroundColor: theme.colors.grey75,
  color: theme.colors.grey700,
  textTransform: 'none',
  ...theme.radius.m,
  ...theme.fonts.header5,
}));

const SessionCustomerAddressList = styled(GridList)(({ maxLength }) => ({
  width: '100%',
  marginBottom: '8px !important',

  '&::-webkit-scrollbar-track': {
    borderRadius: 4,
    backgroundColor: '#FFFFFF',
  },
  '&::-webkit-scrollbar': {
    width: 4,
    backgroundColor: '#FFFFFF',
  },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: 4,
    backgroundColor: '#E8E8E8',
  },
  alignItems: 'flex-start',
  alignContent: 'flex-start',
  margin: '2px 0 !important'
}));

const SessionCustomerAddressItem = styled(GridListTile)((theme) => ({
  // padding: '0 14px 0 0 !important',
  minHeight: theme.isTabletOrMobile ? '82px !important' : '92px !important',
  padding: '0 !important'
}));

function ComponentCustomerAllAddress({
  addressList,
  maxLength,
  onSelect,
  onAdd,
  onEdit,
  selectedId,
}) {
  const { isTablet, isMobile, isDesktopOrLaptop } = useResponsive();
  const word = useLanguage();

  return (
    <>
      <SessionCustomerAddressList
        maxLength={maxLength}
        cellHeight={isMobile ? 128 : isTablet ? 124 : 'auto'}
      >
        {!_.isEmpty(addressList)
          && _.isArray(addressList)
          && addressList.map((item) => (
            <SessionCustomerAddressItem cols={2} key={item.addressId}>
              <ComponentCustomerAddress
                {...item}
                onEdit={() => onEdit(item)}
                onSelect={() => onSelect(item)}
                selected={selectedId === item.addressId}
              />
            </SessionCustomerAddressItem>
          ))}
      </SessionCustomerAddressList>
      <Grid container direction="row" justify="center" alignItems="center">
        <Grid item lg={4} sm={6} xs={12}>
          <ButtonAddMore
            id="add-more-quick"
            data-cta-name-en="Add"
            data-cta-name-th="เพิ่ม"
            data-cta-type="Button"
            fullWidth
            onClick={onAdd}
          >
            {word('Address.Add')}
          </ButtonAddMore>
        </Grid>
      </Grid>
      <Space />
    </>
  );
}

export default ComponentCustomerAllAddress;
